export default __webpack_public_path__ + "static/media/icon-BTC.d1a85829.svg";